<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            
                <form-group label="Name" :required="true">
                  <input
                    type="text"
                    @blur="$v.contact.name.$touch"
                    class="form-control"
                    :class="{ 'is-invalid': $v.contact.name.$error }"
                    v-model="contact.name"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.contact.name.required"
                  >
                    Please enter name
                  </div>
                </form-group>

                <form-group label="Category" :required="true">
                  <b-form-select
                    @blur="$v.contact.category.$touch"
                    :class="{ 'is-invalid': $v.contact.category.$error }"
                    v-model="contact.category"
                    :options="categories"
                  />                  
                 
                  <div
                    class="invalid-feedback"
                    v-if="!$v.contact.category.required"
                  >
                    Please select contact category
                  </div>
                </form-group>

                  <form-group label="Description" :required="true">
                  <input
                    type="text"
                    class="form-control"
                    v-model="contact.description"
                  />
                </form-group>

                <form-group label="Contact Number" :required="true">
                  <input
                    type="text"
                    class="form-control"
                    v-model="contact.contact_number"
                  />
                </form-group>

                <form-group label="Contact Number 2">
                  <input
                    type="text"
                    class="form-control"
                    v-model="contact.contact_number_2"
                  />
                </form-group>

                <form-group label="Email">
                  <input
                    type="email"
                    class="form-control"
                    v-model="contact.email_address"
                  />
                </form-group>


                    <form-group label="Website">
                  <input
                    type="text"
                    class="form-control"
                    v-model="contact.website"
                  />
                </form-group>



              <form-group label="Address">
              <textarea
                class="form-control"
                v-model="contact.address"
              />
            </form-group>

            <form-group label="City">
              <input type="text" class="form-control" v-model="contact.city" />
            </form-group>

            <form-group label="Postal Code">
              <input
                type="text"
                class="form-control"
                v-model="contact.postal_code"
              />
            </form-group>

          <form-group label="Province">
                  <input
                    type="text"
                    class="form-control"
                    v-model="contact.province"
                  />
                </form-group>

                <form-group label="Country">
                  <input
                    type="text"
                    class="form-control"
                    v-model="contact.country"
                  />
                </form-group>

                <form-group label="VAT Number">
                  <input
                    type="text"
                    class="form-control"
                    v-model="contact.vat_number"
                  />
                </form-group>

                <form-group label="Reg Number">
                  <input
                    type="text"
                    class="form-control"
                    v-model="contact.registration_number"
                  />
                </form-group>

                 <form-group label="Notes">
                  <textarea-autosize
                    class="form-control"
                    v-model="contact.notes"
                  />
                </form-group>

          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import contactRepo from "@/api/repos/contactRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    contact: {
     
      name: {
        required,
      },
      category: {
        required,
      },

     
    },
  },

  mounted() {
    this.getContact();
    this.getCreatedData();
  },

  data() {
    return {
      categories:[],
      contact: { },    
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  props: ["id"],

  methods: {
    async getContact() {
      try {
        this.loading = true;
        let { data } = await contactRepo.get(this.id);
        this.contact = data.contact;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getCreatedData() {
      try {
        this.loading = true;
        let { data } = await contactRepo.createRelatedData();
        this.categories = data.categories
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await contactRepo.update(this.id,this.contact);
          this.$emit("contactUpdated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

<style></style>
